export const getMonth = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const getSortingValues = (columns, column, headerSortingState) => {
  let isDataSorted = "";
  let sortingField = "";

  const applySortingToColumns = (cols) => {
    cols?.forEach((col) => {
      if (col?.columns && col?.columns.length > 0) {
        applySortingToColumns(col?.columns); // Recursively handle nested columns
      }

      if (col?.Header === col?.Header) {
        let isDataSortedDesc = false;

        if (
          headerSortingState?.isDataSorted === "" ||
          headerSortingState?.isDataSorted === undefined
        ) {
          isDataSorted = "asc";
          sortingField = column.id;
        } else if (headerSortingState?.isDataSorted === "asc") {
          isDataSorted =
            column.id !== headerSortingState?.accessor ? "asc" : "desc";
          isDataSortedDesc = isDataSorted === "desc";
          sortingField = column.id;
        } else if (headerSortingState.isDataSorted === "desc") {
          isDataSorted =
            column.id !== headerSortingState?.accessor ? "asc" : "";
          isDataSortedDesc = isDataSorted === "desc";
          sortingField = isDataSorted === "asc" ? column.id : "";
        }
        col.isDataSorted = isDataSorted;
        col.sortingField = sortingField;
        col.isDataSortedDesc = isDataSortedDesc;
      } else {
        col.isDataSorted = "";
      }
    });
  };

  applySortingToColumns(columns);

  return { sortingField, isDataSorted };
};
export const rolePaths = {
  "Application Manager": [
    "configuration/settings/ldapConfig",
    "configuration/settings/smtpConfig",
    "configuration/settings/licenseConfig",
    "configuration/administration/userManagement",
    "configuration/settings/loggingConfig",
  ],
};